///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedActionIconDirective } from './red-action-icon.directive';
import { GreenActionIconDirective } from './green-action-icon.directive';
import { OrangeActionIconDirective } from './orange-action-icon.directive';
import { GreyActionIconDirective } from './gray-action-icon.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [RedActionIconDirective, GreenActionIconDirective, OrangeActionIconDirective, GreyActionIconDirective],
    exports: [RedActionIconDirective, GreenActionIconDirective, OrangeActionIconDirective, GreyActionIconDirective]
})
export class ActionIconDirectivesModule {}
